module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-flag-checkered',\n    title: 'Stay compliant',\n    description: 'Do what is necessary to keep yourself and authorities happy in good time.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/7-missions/missions.section-header.html
// module id = 4134
// module chunks = 86